import React from "react"
import { Col, FormControl, MenuItem, Row } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import { blockingFetchService } from "../../lib/blockingFetch"
import apiServerApi from "../../redux/sagas/apiServerApi"
import AlertModal from "../fragments/AlertModal"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../redux/items/types"
import { connect } from "react-redux"

class UpdateLoanBundle extends React.Component {

  state = {
    chooseBundle: false,
    bundleId: '',
    running: false,
    success: false,
    error: null,
  }

  componentDidMount() {
    const { loadBundles } = this.props
    loadBundles()
  }

  doUpdateLoanBundle = (loanId, bundleId) => {

    if(!bundleId) return

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    blockingFetchService(
      accessToken => apiServerApi.updateLoanBundle(accessToken, loanId, bundleId),
      _ => this.updateLoanBundleSuccess(),
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  updateLoanBundleSuccess = () => {
    this.setState({ success: true })
    setTimeout(() => {
      this.setState({ 
        chooseBundle: false,
        bundleId: '',
        running: false,
        success: false,
        error: null
      })
      this.props.onSuccess()
    }, 1000)
  }

  bundleChanged = bundleId => this.setState({ bundleId })

  renderStatuses = (running, error, success) => {

    if(!error && !success && !running) return null

    const statusText = error ? error : running ? 'Running..' : success ? 'Completed successfully' : null,
    statusFontName = error ? 'exclamation-circle' : running ? 'clock-o' : 'check',
    statusClassName = error ? 'error-color' : running ? 'hot-color' : 'green'
    return <p className={ `${statusClassName} mt-10` }>
      <FontAwesome name={ statusFontName }/> { statusText }
    </p>
  }

  renderCardContent = () => {

    const { loan, bundles } = this.props,
    { bundleId, running, error, success } = this.state,
    loanCollateral = loan.bundle.loanCollateral,
    loanBundleId = loan.bundle.id

    return (
    <Row>

      <Col xs={4}>Choose a bundle</Col>

      <Col xs={8}>
        <FormControl componentClass="select" placeholder="select" disabled={ running }
          value={ bundleId }
          onChange={e => this.bundleChanged(e.target.value)}>
          <option value=""></option>
          { bundles
            .filter(bundle => bundle.loanCollateral === loanCollateral && bundle.id !== loanBundleId)
            .map(bundle => <option key={ bundle.id } value={ bundle.id }>
          { bundle.name } #{ bundle.shortName } - { bundle.cost } { bundle.currencyCode }</option>) }
        </FormControl>

        { this.renderStatuses(running, error, success) }
      </Col>
    </Row>
  )}

  render() {
    const { loan, waitForRecording } = this.props,
    { chooseBundle, bundleId, running } = this.state

    return (
      <MenuItem
        eventKey="5"
        title="Update the bundle for this loan"
        onClick={() => {
          if(!waitForRecording) {
            this.setState({ chooseBundle: true })
          }
        }}
        disabled={ waitForRecording }>
        <span><FontAwesome name='pencil'/> Update Loan Bundle</span>

        <AlertModal
          title="Update Loan Bundle"
          show={ chooseBundle }
          close={() => this.setState({ chooseBundle: false })}
          body={ this.renderCardContent() }
          confirm={() => this.doUpdateLoanBundle(loan.id, bundleId) }
          proceedText="Proceed"
          bsStyle="primary"
          disabled={ running || !bundleId }
        />
      </MenuItem>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  loadBundles: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.Bundle)),
})

const mapStateToProps = state => {
  const bundles = DckSelectors.selectAllItems(state, ItemTypes.Bundle)
  return { bundles }
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateLoanBundle)



// WEBPACK FOOTER //
// ./src/components/Loans/UpdateLoanBundle.js